
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Container } from '@/components/layout/container';
import ThemeSwitcher from '@/components/theme/ThemeSwitcher';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-directpress-dark py-4 sticky top-0 z-50 shadow-sm">
      <Container>
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="text-white text-h2 font-bold">Direct<span className="text-directpress-orange">Press</span></span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-body text-white/80 hover:text-white transition-colors duration-200">Features</a>
            <a href="#how-it-works" className="text-body text-white/80 hover:text-white transition-colors duration-200">How It Works</a>
            <a href="#pricing" className="text-body text-white/80 hover:text-white transition-colors duration-200">Pricing</a>
            <div className="flex space-x-4">
              <Button variant="tertiary" asChild className="text-directpress-dark font-medium border-white/40 hover:bg-white">
                <Link to="/auth">Log In</Link>
              </Button>
              <Button asChild className="bg-directpress-orange hover:bg-directpress-orange/90">
                <Link to="/auth?tab=sign-up">Sign Up</Link>
              </Button>
            </div>
            <ThemeSwitcher publicPage={true} />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)} 
              className="text-white hover:text-directpress-orange transition-colors duration-200"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-white/20 animate-fade-in">
            <div className="flex flex-col space-y-4">
              <a 
                href="#features" 
                className="text-body text-white hover:text-directpress-orange transition-colors duration-200 py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Features
              </a>
              <a 
                href="#how-it-works" 
                className="text-body text-white hover:text-directpress-orange transition-colors duration-200 py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                How It Works
              </a>
              <a 
                href="#pricing" 
                className="text-body text-white hover:text-directpress-orange transition-colors duration-200 py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Pricing
              </a>
              <div className="flex flex-col space-y-3 pt-2">
                <Button variant="tertiary" className="w-full text-directpress-dark font-medium border-white/40 hover:bg-white" asChild>
                  <Link to="/auth" onClick={() => setIsMenuOpen(false)}>Log In</Link>
                </Button>
                <Button className="w-full bg-directpress-orange hover:bg-directpress-orange/90" asChild>
                  <Link to="/auth?tab=sign-up" onClick={() => setIsMenuOpen(false)}>Sign Up</Link>
                </Button>
              </div>
            </div>
          </div>
        )}
      </Container>
    </nav>
  );
};

export default Navbar;
